import React from 'react';

const FundingAIAdvisorEmptyState = ({ hasClient, onGenerate }) => (
  <div className="rounded-2xl border border-dashed border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-8 text-center">
    <div className="text-base font-semibold text-[var(--fg-text)]">Funding command advisor</div>
    <p className="mx-auto mt-2 max-w-md text-sm text-[var(--fg-muted)]">
      {hasClient
        ? 'Ask for recommended next steps based on this client’s readiness, documents, matches, and pipeline data.'
        : 'Portfolio mode uses agency-wide signals to recommend where to focus next. Select a client for client-specific strategy.'}
    </p>
    <p className="mx-auto mt-3 max-w-md text-xs text-[var(--fg-muted)]">
      Guidance is estimated and based on available data — not a guarantee of approval or funding.
    </p>
    {onGenerate ? (
      <button
        type="button"
        onClick={onGenerate}
        className="mt-4 text-sm font-medium text-[var(--fg-accent)] hover:underline"
      >
        Generate recommendations
      </button>
    ) : null}
  </div>
);

export default FundingAIAdvisorEmptyState;
